import parse from "html-react-parser";
import DOMPurify from "dompurify";

const safeHtml = (html) => parse(DOMPurify.sanitize(html ?? ""));

export default safeHtml;
